var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "p-l-5" }, [
    _c("div", { staticClass: "m-b-2 m-t-5" }, [
      _c("strong", [_vm._v(_vm._s(_vm.columnDisplayName))])
    ]),
    _vm._v(" "),
    _c(
      "table",
      { staticClass: "table_beauty condensed-alternate routing-plan-args" },
      [
        _c("thead", [
          _c("tr", { staticClass: "bg-transparent" }, [
            _c(
              "th",
              { staticClass: "text-right routing-plan-args__priority" },
              [_vm._v("\n          Priority\n        ")]
            ),
            _vm._v(" "),
            _c("th", { staticClass: "text-right routing-plan-args__weight" }, [
              _vm._v("\n          Weight\n        ")
            ]),
            _vm._v(" "),
            _c("th", [_vm._v("Name")]),
            _vm._v(" "),
            _vm.columnName.toLowerCase() === "ineligibletargets"
              ? _c("th", [_vm._v("\n          Reason\n        ")])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.parsedCallPlanDetail, function(target, index) {
            return _c("tr", { key: index, staticClass: "bg-transparent" }, [
              _c("td", { staticClass: "text-right" }, [
                _vm._v("\n          " + _vm._s(target.priority) + "\n        ")
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "text-right" }, [
                _vm._v("\n          " + _vm._s(target.weight) + "\n        ")
              ]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(target.name))]),
              _vm._v(" "),
              _vm.columnName.toLowerCase() === "ineligibletargets"
                ? _c("td", [
                    _vm._v(
                      "\n          " +
                        _vm._s(target.ineligibilityReason) +
                        "\n        "
                    )
                  ])
                : _vm._e()
            ])
          }),
          0
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }